import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import PerfilColaboradorServices from "./PerfilColaborador.service";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getFormacionColaborador = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_FORMACION_COLABORADOR,
      payload: true,
    });
    const resp = await PerfilColaboradorServices.getFormacionColaborador(filters);

    dispatch({
      type: actions.GET_FORMACION_COLABORADOR,
      payload: {
        formacionColaborador: resp.data,
      },

    });
    dispatch({
      type: actions.FORMACION_COLABORADOR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FORMACION_COLABORADOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FORMACION_COLABORADOR,
      payload: false,
    });
  }
};

export const clearFormacionColaborador = () => async (dispatch) => {
  try {    
    console.log("ver")
    dispatch({
      type: actions.GET_FORMACION_COLABORADOR,
      payload: {
        formacionColaborador: null,
      },

    });
    dispatch({
      type: actions.FORMACION_COLABORADOR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FORMACION_COLABORADOR_FAIL,
      payload: message,
    });
  } 
};


export const saveFormacionColaborador =
  (data) => async (dispatch) => {
    try {
      dispatch({
        type: actions.LOADING_FORMACION_COLABORADOR,
        payload: true,
      });
      await PerfilColaboradorServices.createFormacionColaborador(data);
      const resp = await PerfilColaboradorServices.getFormacionColaborador(data);

      dispatch({
        type: actions.GET_FORMACION_COLABORADOR,
        payload: {
          formacionColaborador: resp.data
        },
      });
      dispatch({
        type: actions.FORMACION_COLABORADOR_FAIL,
        payload: "",
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.FORMACION_COLABORADOR_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_FORMACION_COLABORADOR,
        payload: false,
      });
    }
  };

export const editFormacionColaborador =
  (data, id, filterGetRequest) => async (dispatch) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_FORMACION_COLABORADOR,
        payload: true,
      });
      debugger
      await PerfilColaboradorServices.editFormacionColaborador(id, data);
      const resp = await PerfilColaboradorServices.getFormacionColaborador(filterGetRequest);

      dispatch({
        type: actions.GET_FORMACION_COLABORADOR,
        payload: {
          formacionColaborador: resp.data
        },
      });
      dispatch({
        type: actions.FORMACION_COLABORADOR_FAIL,
        payload: "",
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.FORMACION_COLABORADOR_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_FORMACION_COLABORADOR,
        payload: false,
      });
    }
  };